import { Navigate, useLocation } from 'react-router-dom';
import { hasRole, useAuth, type Role } from './AuthProvider';

interface Props {
  roles: Role[];
  children: React.ReactNode;
}

export default function RequireRole({ roles, children }: Props) {
  const { ready, user, groups } = useAuth();
  const location = useLocation();

  if (!ready) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!hasRole(groups, ...roles)) {
    return (
      <div className="mx-auto max-w-md py-12 text-center text-zinc-400">
        <h1 className="text-lg font-semibold text-zinc-100">Not authorized</h1>
        <p className="mt-2 text-sm">
          This area requires one of: {roles.join(', ')}.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
